
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetPageByIdData } from "../../../lib/data";
import EditRolesUi from "../../../ui/rolesui/EditRolesUi";
import i18n from "../../../lib/i18n";
import EditPagesUi from "../../../ui/pages/editPages";

export default function EditPages() {

    const { pageId } = useParams();
    const [pagesData, setPagesData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const pageData = await GetPageByIdData(pageId);
        setPagesData(pageData.data);
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.page")}</h1>
                <EditPagesUi data={pagesData} />
            </div>
        </div>
    );
};